import React from "react";
import "./CSS/Categories.css";
import { useNavigate } from "react-router-dom";

import crdbg from "./IMAGES/030baf24263fe4ae6abe7c3522b06880211742a7.png";
import saree from "./IMAGES/Category Saree.png";
import kurti from "./IMAGES/Category Kurtis.png";
import dresses from "./IMAGES/Category Dresses.png";
import blouse from "./IMAGES/Category Blouse.png";
import tops from "./IMAGES/Category Tops.png";

const Categories = () => {
  const navigate = useNavigate();

  const categories = [
    { id: 1, name: "Sarees", image: saree },
    { id: 2, name: "Dresses", image: dresses },
    { id: 3, name: "Kurti", image: kurti },
    // { id: 4, name: "Lehenga", image: dresses },
    { id: 5, name: "Tops", image: tops },
    { id: 6, name: "Blouse", image: blouse },
  ];

  const handleCategoryClick = (category) => {
    navigate(`/shop?categoryId=${category.id}`, {
      state: {
        categoryId: category.id,
        categoryName: category.name,
      },
    });
  };

  return (
    <div className="categories-container">
      {/* ================= HEADER ================= */}
      <div className="categories-header">
        <div>
          <h1>Exclusive Categories</h1>

          <p>
            Explore our handcrafted collections, tailored for every generation.
          </p>
        </div>
      </div>

      {/* ================= CATEGORY LIST ================= */}
      <div className="categories-card-wrapper">
        {categories.map((category) => (
          <div
            className="categories-card"
            key={category.id}
            role="button"
            tabIndex={0}
            onClick={() => handleCategoryClick(category)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleCategoryClick(category);
              }
            }}
          >
            {/* IMAGE CIRCLE */}
            <div
              className="category-circle"
              style={{ backgroundImage: `url(${crdbg})` }}
            >
              <img src={category.image} alt={category.name} />
            </div>

            {/* CATEGORY NAME */}
            <p className="category-name">{category.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
